import { Box, Typography } from '@mui/material';

const VersionNumber = () => {
  return (
    <Box sx={{ position: 'fixed', bottom: 16, left: 0, right: 0, zIndex: 0, pointerEvents: 'none' }}>
      <Typography sx={{ opacity: 0.5 }} color="secondary" textAlign="center" fontSize={10}>
        {import.meta.env.VITE_APP_VERSION}
      </Typography>
    </Box>
  );
};

export default VersionNumber;
